// extracted by mini-css-extract-plugin
export var timeToReadContainer = "bq_dY";
export var timerIcon = "bq_dZ";